export const LUX_LOYALTY = {
  PROGRAM_NAME: 'Lux Loyalty',
  LANDING_PAGE: 'lux-loyalty',
} as const
